// set submit button props
const submitButton = (state = {}, action) => {
  switch (action.type) {
    case 'SET_SUBMIT_BUTTON_PROPS':
      return { ...state, ...action.data }

    default:
      return state
  }
}

export default submitButton
